import { Injectable } from '@angular/core';

import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthenticationService } from '../../shared/_services/authentication.service';
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentUser = this.authenticationService.currentUserValue;
        const currentDoctor = this.authenticationService.currentDoctorValue;
        const currentAdmin = this.authenticationService.currentAdminValue;
        if (currentUser || currentDoctor || currentAdmin) {
            if (currentUser && currentUser.authdata) {

                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${currentUser.authdata}`
                    }
                });


            }
            if (currentDoctor && currentDoctor.authdata) {

                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${currentDoctor.authdata}`
                    }
                });

            }
            if (currentAdmin && currentAdmin.authdata) {

                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${currentAdmin.authdata}`
                    }
                });
            }
        }



        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {

                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {

                let data = {};
                data = {
                    reason: error && error.error && error.error.reason ? error.error.reason : '',
                    status: error.status
                };

                return throwError(error);

            }));
    }
}